import { render, staticRenderFns } from "./GuaranteeBadge.vue?vue&type=template&id=6d279655&"
import script from "./GuaranteeBadge.vue?vue&type=script&lang=js&"
export * from "./GuaranteeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\cwallenfang\\Documents\\PlentyDevTool\\2227\\60\\ETCeresCoconut\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d279655')) {
      api.createRecord('6d279655', component.options)
    } else {
      api.reload('6d279655', component.options)
    }
    module.hot.accept("./GuaranteeBadge.vue?vue&type=template&id=6d279655&", function () {
      api.rerender('6d279655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/GuaranteeBadge.vue"
export default component.exports